var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTranslate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.67,143.91c-6.87,5.78-13.34,8.79-16.63,8.79v12.8c8.25,0,18.16-6,25.6-12.43,7.45,6.39,17.36,12.43,25.6,12.43V152.7c-3.28,0-9.76-3-16.62-8.79,3.71-4.52,7.62-10.43,9.33-16.81h13.69V114.3H204V101.5h-12.8v12.8h-25.6v12.8h13.69C181,133.48,185,139.39,188.67,143.91Zm13.7-16.82a39.71,39.71,0,0,1-4.73,7.57,39.62,39.62,0,0,1-4.72-7.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.05,145.1h14.8l6.32-14.56H81.59l6.32,14.56h14.7L69.48,74.38Zm26.3-26.43,7.12-16.43,7,16.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2,223.71l-25.94-37.08H0V30.29H106.9l9.41,23.65H256V223.71Zm101.05-14V67.94H121.89l45.25,118.69h0l-11.29,23.08Zm-98.55-6.57,8.07-16.51H132.14Zm4-30.51L97.63,44.29H13.75V172.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTranslate);
export default __webpack_public_path__ + "static/media/icon-translate.070baea4.svg";
export { ForwardRef as ReactComponent };